"use client";
import TrustedByClients from "@/app/api_home/trustedByClients";
import clsx from "clsx";
import { avenirNextMedium, avenirNextRegular } from "@/styles/fonts";
import { openFreeModal } from "./freeModal";


export default function HomeUseForFree() {
  return (
    <section className={clsx("bg-[#13172c] w-full",
      "pt-[30px] sm:pt-[50px] md:pt-[70px] lg:pt-[110px]",
      "pb-[25px] sm:pb-[45px] md:pb-[30px] lg:pb-[60px]",
      "px-[15px]"
    )}>
      <div className={clsx("mx-auto",
        "w-full md:w-[750px] lg:w-[970px] xl:w-[1170px]",
        "md:px-[30px]"
      )}>
        <h1 className={clsx(avenirNextMedium.className, "text-white",
          "text-[21px] sm:text-[35px] md:text-[45px] lg:text-[48px]",
          "lg:leading-[52.8px]",
          "mb-[15px] md:mb-[20px] lg:mb-[30px]"
        )}>
          Use Adbeat For Free
        </h1>
        <p className={clsx(avenirNextRegular.className, "mx-auto text-[#CCCCCC]",
          "w-full lg:w-[70%]",
          "mb-[30px] md:mb-[45px]",
          "text-[14px] sm:text-[19px] lg:text-[20px]")}>
          Improve your display advertising campaigns with competitive insights from millions of advertisers and publishers.
        </p>
        <button
          onClick={() => { openFreeModal(); }}
          className={clsx(avenirNextMedium.className,
            "bg-[linear-gradient(to_bottom,#34aa44_0%,#39b54a_100%)]",
            "rounded-[6px] text-white",
            "text-[13px] sm:text-[16px] md:text-[18px]",
            "leading-[18.5px] sm:leading-[22.8px] md:leading-[25.7px]",
            "px-[24px] py-[10px] md:px-[60px] md:py-[16px]",
            "mb-[50px] md:mb-[80px]")}>
          Sign up for your free account
        </button>
        <p className={clsx(avenirNextMedium.className, "text-[#CCCCCC]",
          "mb-[35px] sm:mb-[25px] lg:mb-[35px]",
          "text-[13px] sm:text-[16px] lg:text-[16px]")}>
          Trusted by the world&apos;s top advertisers, agencies, and publishers
        </p>

        <TrustedByClients />
      </div>
    </section>
  )
}